/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { UserService } from './services/user.service';
import { PlanService } from './services/plan.service';
import { ItemService } from './services/item.service';
import { PurchaseService } from './services/purchase.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    UserService,
    PlanService,
    ItemService,
    PurchaseService,
    ApiConfiguration
  ],
})
export class PointsApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<PointsApiModule> {
    return {
      ngModule: PointsApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: PointsApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('PointsApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
